import styled from 'styled-components'
import RoomChargeIcon from '../../../img/svg/roomCharge'
import { colorTheme } from '../../../style/theme/colorTheme'

export const KeypadKeyButton = styled.button`
	font-size: 1rem;
	display: grid;
	place-items: center;
	border: 1px solid ${colorTheme.roomCharge.keypad.border};
	border-radius: 0.75em;
	background: ${colorTheme.roomCharge.keypad.background};
	color: ${colorTheme.roomCharge.keypad.text};
	transition: all 0.2s;

	&:active {
		transform: scale(0.95);
		background: ${colorTheme.roomCharge.keypad.active};
	}
`
KeypadKeyButton.displayName = 'KeypadKeyButton'

export const KeypadDigitGrid = styled.div`
	font-size: 1rem;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 1em;
`
KeypadDigitGrid.displayName = 'KeypadDigitGrid'

export const KeypadDigitKey = styled(KeypadKeyButton)`
	font-size: 2em;
	height: 2.5em;
`
KeypadDigitKey.displayName = 'KeypadDigitKey'

export const KeypadZeroKey = styled(KeypadDigitKey)`
	grid-column-start: 2;
`
KeypadZeroKey.displayName = 'KeypadZeroKey'

export const KeypadDigitDeleteKey = styled(KeypadKeyButton)`
	height: 5em;
`
KeypadDigitDeleteKey.displayName = 'KeypadDigitDeleteKey'


export const KeypadBackspaceIcon = styled(RoomChargeIcon)`
	width: 1.93em;
	height: 1.31em;
	color: ${colorTheme.roomCharge.keypad.icon};
`
KeypadBackspaceIcon.displayName = 'KeypadBackspaceIcon'
